// Slide decks associated with Object-Oriented Programming (OOP) sprint 6

import { xyz_n_1of4 } from './SL00000Sprint00TTR'
import { orderedListSlide } from './SLSprint00'

import { list24500Sprint05 } from '../ActivityLists/AL24500Sprint05'
import { list24500Sprint06 } from '../ActivityLists/AL24500Sprint06'

const sprint = 6
const activityList = () => { return list24500Sprint06(sprint) }
const activityListPrevious = () => { return list24500Sprint05(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Session 1 of 4: Tuesday
const oop_6_1of4 = () => {
	const sprintPlanningExpectations = () => {
		return orderedListSlide('Sprint Planning', `Sprint ${sprint} Expectations:`, [
			'Similar to other sprints with Discussion, Quiz, Lab, and Reflection',
			'Different in that we will have our Midterm Exam in class next Tuesday with in-person attendance required',
			`Similar in that we will have two weeks to complete all sprint ${sprint} assignments`,
			`Similar in that we will have sprint ${sprint-1} Demos and Retrospectives on Thursday`,
			`Similar in that we will complete Discussion Board ${sprint} as a scrum team in class on Thursday` ])
	}
	return xyz_n_1of4(null, null, sprintAndActivityLists, sprintPlanningExpectations) 
}

// Session 2 of 4: Thursday
/* Todo: Figure out what breakout session we should have Thursday... Likely multithreading related 
import { breakoutStandard } from './SLSprint00'

const breakoutRequirementsGUI = 'Graphical User Interfaces plus Action Listeners'
const breakoutGUI = () => {
	return breakoutStandard( 
		`${breakoutRequirementsGUI} Breakout`, 
		`In this breakout session on “${breakoutRequirementsGUI}” your team will discuss:`, [
		'Recall: AWT... What does that stand for?',
		'Recall: Swing, SWT, and JavaFX',
		'Recall: How is Android related to Java?',
		'Review: Layout Managers in Java',
		'Review:Class Inheritance vs. Composition vs. Interfaces',
		'Action Listeners',
		'Action Listener, Classes, Objects, and Interfaces'
	 ])
}
*/

export const oop_6_slidedeckTTR = [ oop_6_1of4, null, null, null ]